module.exports = __webpack_public_path__ + "static/pokoj-nr3-photo02-nikon-f13747bbea4efee0bbb8834f66548d10.jpg";